import React from 'react';
import ReleaseCard from './ReleaseCard';

export default function ReleaseV191({ createThumbnail }) {
  return (
    <ReleaseCard version="v1.9.1" date="15th February 2026" title="First release of 2026!">
      <p className="text-gray-300 mb-4">Here's what's new:</p>
      <div className="mb-6">
        <h5 className="text-lg font-medium text-purple-400 mb-2">Start a Game in 3 Taps</h5>
        <p className="text-gray-300 mb-3">No registration. No friction. Just play.</p>
        <p className="text-gray-300 mb-3">
          We've completely reimagined how you get into a game. Players can now join and start playing in just three taps—no account creation, no email verification, no waiting. Tap to find a game, tap to join, tap to play. Whether you're a first-timer or a regular, the path to the felt has never been smoother.
        </p>
        <p className="text-gray-300 mb-3">
          This streamlined experience means more time at the table and less time in setup. Perfect for walk-ins, quick sessions, or anyone who just wants to sit down and play without the usual app friction.
        </p>
        <div className="mt-4 flex flex-wrap gap-4">
          {createThumbnail('/v1.9.1/quickStart.png', 'Quick Start - find a game in 3 taps with no login needed')}
          {createThumbnail('/v1.9.1/nowOrTailor.png', 'Choose to start now or tailor your game setup')}
          {createThumbnail('/v1.9.1/tailor.png', 'Tailor your game options before starting')}
        </div>
      </div>

      <p className="text-gray-300 mb-4">We've also made some other improvements to the app:</p>
      <ul className="text-gray-400 space-y-2 mb-4">
        <li>• <strong>Smart Power Warnings</strong> - Alerts you if your phone is in Low Power or Silent mode.</li>
        <li>• <strong>Smarter Alarms</strong> - No unexpected sounds if notifications are muted.</li>
        <li>• <strong>Stronger Connection</strong> - Reworked clock sync for a smoother, more stable experience.</li>
        <li>• <strong>Enhanced Security</strong> - Improved device ↔ server protection.</li>
        <li>• <strong>Game Activity Log</strong> - View full game history from the Game Details screen.</li>
        <li>• <strong>UI Polish</strong> - Cleaner layouts. Better flow.</li>
        <li>• <strong>Bug Fixes & Performance Boosts</strong></li>
      </ul>
    </ReleaseCard>
  );
}
